
import React from 'react';

interface BlogSectionHeaderProps {
  isVisible: boolean;
}

const BlogSectionHeader: React.FC<BlogSectionHeaderProps> = ({ isVisible }) => {
  return (
    <div className={`mb-8 sm:mb-12 transition-all duration-500 ${
      isVisible ? 'opacity-100 translate-y-0 fade-up' : 'opacity-0 translate-y-8'
    }`}>
      <p className="heading-highlight mb-2 animate-pulse-slow">Technical Writing</p>
      <h2 className="text-2xl sm:text-3xl font-bold mb-3 sm:mb-4">Featured Articles</h2>
      <p className="text-muted-foreground max-w-2xl text-sm sm:text-base">
        A curated collection of engineering essays on React architecture, JavaScript internals, and performance optimization.
      </p>
    </div>
  );
};

export default BlogSectionHeader;
